import React from 'react';
import './aboutPage.css';

export default function AboutPage(){
    return(
        <div className="container-fluid AboutContainer">
            <div className="row mt-2">
                <div className="col">
                <p className="MainTitle text-center">Mission Driven Software Engineer</p>
                </div>
            </div>
            <div className="row mt-2">
                <div className="col">

                    <p className="Title text-center">GET TO KNOW ME</p>
                    
                    <p className="EducationText">
                        <span className="Qualification">PG Diploma in ML and AI</span> - IIIT Bangalore</p>
                    <p className="EducationText">
                        <span className="Qualification">B.Tech in Computer Science and Engineering</span> - VIT university</p>
                
                    <p className="ContentText">
                        Around 6+ years of experience in complete SDLC with delivering solutions in various tech and stack and proven ability in solving complex problems
                    </p>

                </div>
            </div>

            <div className="row mt-2">
                <div className="col">
                    <p className="Title text-center">INTERESTS</p>
                    <p className="ContentText">
                    Apart from being a Software Engineer, I enjoy few hobbies and challenging myself. When it comes to outdoor, I play football and Table Tennis over the weekends. 
                    When forced indoor, I would love Gaming, reading novels and learning something new as well.
                    </p>
                </div>
            </div>

        </div>
    );
}
